import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Section, SectionTitle } from './Shared';
export function IsForYou() {
  return <div className="bg-sage-light/20" data-id="element-126">
      <Section className="max-w-3xl" data-id="element-127">
        <SectionTitle data-id="element-128">Esta guía es para vos si…</SectionTitle>

        <div className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-beige-muted/50 mt-8" data-id="element-129">
          <div className="space-y-5" data-id="element-130">
            {['Querés estimular a tu bebé sin estrés', 'No sabés qué actividades hacer', 'Buscás menos pantallas', 'Querés acompañar su desarrollo desde casa', 'Tenés poco tiempo', 'Querés sentir más conexión y tranquilidad'].map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-131">
                <CheckCircle2 className="w-6 h-6 text-cta flex-shrink-0 mt-0.5" data-id="element-132" />
                <p className="text-lg text-charcoal font-medium" data-id="element-133">{item}</p>
              </div>)}
          </div>
        </div>
      </Section>
    </div>;
}